import { useFetch } from "@chainless/chainless-react";
import { useEffect, useState } from "react";
import { CreateNewsItem } from "../components/CreateNewsItem";
import "./pages.css";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { ImagePopup } from "../components/ImagePopup";
import { DeleteNewsItem } from "../components/DeleteNewsItem";
import { FaPencilAlt } from "react-icons/fa";

export const NieuwsPage = () => {
  const [create, setCreate] = useState(false);
  const [newsList, setNewsList] = useState([]);
  const [updateId, setUpdate] = useState(null);
  const {
    data: news,
    error,
    loading,
    fetchData,
  } = useFetch(`/api/news`);

  const refreshAll = () => {
    setNewsList([]);
    fetchData();
  };

  useEffect(() => {
    if (news && news.length > 0) {
      const uniqueNews = news.filter(
        (newNews) =>
          !newsList.find((existingNews) => existingNews.id === newNews.id)
      );
      setNewsList((prevNews) => [...prevNews, ...uniqueNews]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [news]);

  const updateNewsItem = (id) => {
    setUpdate(id);
    setCreate(true);
  };

  return (
    <div className="content">
      <h1>Laatste Nieuws</h1>
      {!create ? (
        <>
          <button onClick={() => setCreate(!create)}>
            Nieuwsbericht maken
          </button>
          {loading && <p>Nieuws ophalen...</p>}
          {error && <p>Error bij ophalen nieuws: {error}</p>}
          {news && (
            <div className="table">
              <DataTable
                value={newsList}
                stripedRows
                showGridlines
                paginator={false}
                rows={10}
              >
                <Column
                  className="table-column"
                  field="timestamp"
                  header="Datum/tijd"
                  body={(rowData) =>
                    new Date(rowData.timestamp * 1000).toLocaleString("nl-NL")
                  }
                />
                <Column className="table-column" field="title" header="Title" />
                <Column
                  className="table-column"
                  field="author"
                  header="Author"
                />
                <Column
                  className="table-column"
                  field="foto"
                  header="Foto"
                  body={(rowData) => (
                    <ImagePopup src={`/api/images/${rowData.foto}`} />
                  )}
                />
                <Column
                  className="table-column"
                  field="actions"
                  header="Actions"
                  body={(rowData) =>
                    rowData.id && (
                      <>
                        <DeleteNewsItem id={rowData.id} refresh={refreshAll} />
                        <FaPencilAlt
                          onClick={() => updateNewsItem(rowData.id)}
                        />
                      </>
                    )
                  }
                />
              </DataTable>
            </div>
          )}
        </>
      ) : (
        <CreateNewsItem
          setCreate={setCreate}
          refresh={refreshAll}
          id={updateId}
          setUpdate={setUpdate}
        />
      )}
    </div>
  );
};
